import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const getHealthJourneyState = (state: RootState) => state.healthJourney;

export const selectHealthJourneys = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.healthJourneys
);

export const selectHealthJourneysNumber = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => {
    return healthJourneyState.healthJourneys.length;
  }
);

export const selectHealthJourney = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.selectedHealthJourney
);

export const selectLoadingHealthJourneys = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.loadingHealthJourneys
);

export const selectHealthPictureUpdateDate = createSelector(
  [getHealthJourneyState],
  (healthPictureState) => healthPictureState.healthPicture?.dateCreated
);

export const selectHealthJourneyTimeline = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.healthJourneyTimeline.data
);

export const selectTimelinexMsContinuationToken = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) =>
    healthJourneyState.healthJourneyTimeline.xMsContinuationToken
);

export const selectLoadingHealthJourneyTimeline = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.loadingHealthJourneyTimeline
);

export const selectErrorHealthJourneyTimeline = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.errorHealthJourneyTimeline
);

export const selectHealthPicture = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.healthPicture
);

export const selectLoadingHealthPicture = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.loadingHealthPicture
);

export const selectErrorHealthPicture = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.errorHealthPicture
);

export const selectOngoingDiagnoses = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) =>
    healthJourneyState.healthPicture?.diagnoses.filter(
      (diagnosis) => !diagnosis.dateEnded
    )
);

export const selectCompletedDiagnoses = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) =>
    healthJourneyState.healthPicture?.diagnoses.filter((diagnosis) =>
      Boolean(diagnosis.dateEnded)
    )
);

export const selectOngoingSymptoms = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) =>
    healthJourneyState.healthPicture?.symptoms.filter(
      (symptom) => !symptom.dateEnded
    )
);

export const selectCompletedSymptoms = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) =>
    healthJourneyState.healthPicture?.symptoms.filter((symptom) =>
      Boolean(symptom.dateEnded)
    )
);

export const selectOngoingTreatments = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) =>
    healthJourneyState.healthPicture?.treatments.filter(
      (treatment) => !treatment.dateEnded
    )
);

export const selectCompletedTreatments = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) =>
    healthJourneyState.healthPicture?.treatments.filter((treatment) =>
      Boolean(treatment.dateEnded)
    )
);

export const selectCurrentHealthPicture = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.currentHealthPicture
);

export const selectCanCreateJourneyForMyself = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) =>
    healthJourneyState.healthJourneys.filter((journey) => {
      return journey.relationship === 'me';
    }).length === 0
);

export const selectIsOpenCreateJourneyDialog = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.isOpenCreateJourneyDialog
);

export const selectSymptomCheckerResults = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.symptomCheckerResults
);

export const selectLoadingSymptomCheckerResults = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.loadingSymptomCheckerResults
);

export const selectPreselectedHealthJourneyTab = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.preselectHealthJourneyTab
);

export const selectMyCareChangeEvent = createSelector(
  [getHealthJourneyState],
  (healthJourneyState) => healthJourneyState.myCareChangeEvent
);
